import React, {useCallback} from 'react';
import styled from 'styled-components';
import {useAppContext} from 'contexts/ApplicationContext';
import {useFreightContext} from 'components/customer/Confirmation/Freight';
import {RequestedDeliveryDatePicker} from 'components/customer/Job/components/RequestedDeliveryDatePicker';
import {DispatchMethod} from 'hooks/Job/Job';

// requested delivery date for pickup and freight on the freight tab, same as
// the job form's when delivery details are captured there instead
export const RequestedDeliveryDateField = () => {
    const {userProfile} = useAppContext();
    const {requestedDeliveryDate, setRequestedDeliveryDate, dispatchMethod} =
        useFreightContext();
    const isRequired = !!userProfile?.requireDeliveryDateRequest;
    const isPickup = dispatchMethod == DispatchMethod.PICKUP;

    const handleChange = useCallback(
        (value: string) => setRequestedDeliveryDate?.(value),
        [setRequestedDeliveryDate]
    );

    return (
        <Field>
            <label htmlFor="freight-requested-delivery-date">
                {isPickup ? 'Requested Pickup Date' : 'Requested Delivery Date'}
                {isRequired ? <span>*</span> : <small>Optional</small>}
            </label>
            <RequestedDeliveryDatePicker
                id="freight-requested-delivery-date"
                value={requestedDeliveryDate}
                onChange={handleChange}
                minimumLeadTime={userProfile?.minimumLeadTime ?? 0}
                placeholder={
                    isPickup ? 'Select a pickup date' : 'Select a delivery date'
                }
            />
        </Field>
    );
};

const Field = styled.div`
    > label {
        display: flex;
        align-items: baseline;
        gap: 6px;
        margin-bottom: 6px;
        color: ${({theme}) => theme.colors?.primary?.main};
        font-size: 0.85rem;
        font-weight: 600;

        > span {
            color: ${({theme}) => theme.colors?.errorLabel?.main};
        }

        > small {
            color: #8a8a8a;
            font-size: 0.75rem;
            font-weight: 400;
        }
    }
`;
